export default __webpack_public_path__ + "static/media/search-solid.def5cb3c.svg";